import { render } from "./Watchlist.vue?vue&type=template&id=791db98a&scoped=true"
import script from "./Watchlist.vue?vue&type=script&lang=js"
export * from "./Watchlist.vue?vue&type=script&lang=js"

import "./Watchlist.vue?vue&type=style&index=0&id=791db98a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dotter/dotter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791db98a"]])

export default __exports__